


















  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component
  export default class OneCartModalAdd extends Vue {
    cartName: string = ''

    @Prop({
      type: Boolean,
      required: true,
    })
    value!: boolean;

    @Prop({
      type: Boolean,
      required: false,
      default: false,
    })
    progress!: boolean;

    @Prop({
      type: Number,
      required: false,
      default: 17,
    })
    max!: number;

    get isValid() {
      return this.cartName.trim().length < this.max
    }

    @Watch('value')
    onVisibilityChange() {
      this.cartName = ''
    }

    onSave() {
      this.$emit('create', this.cartName.trim())
    }
  }
